function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#43a047",
  d: "M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8e6c9",
  d: "M40 13L30 13 30 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2e7d32",
  d: "M30 13L40 23 40 13z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e8f5e9",
  d: "M31,23H17h-2v2v2v2v2v2v2v2h18v-2v-2v-2v-2v-2v-2v-2H31z M17,25h4v2h-4V25z M17,29h4v2h-4V29z M17,33h4v2h-4V33z M31,35h-8v-2h8V35z M31,31h-8v-2h8V31z M31,27h-8v-2h8V27z"
});

const SvgGooglesheets = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  width: "32px",
  height: "32px",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGooglesheets, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/googlesheets.08540b92.svg";
export { ForwardRef as ReactComponent };